<template>
  <router-view />
</template>

<script setup lang="ts">
// Root app component - just renders router-view
// All layout is handled by AdminLayout.vue
</script>

<style>
/* Root styles applied globally */
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

html, body, #app {
  width: 100%;
  height: 100%;
  overflow: hidden;
}

body {
  font-family: system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
</style>
